import { Skeleton } from '@/shared/ui'

import styles from './withdrawal-loading.module.scss'

export const WithdrawalLoading = () => {
    return (
        <div className={styles['withdrawal-loading']}>
            <div className={styles['withdrawal-loading__balance']}>
                <div className={styles['withdrawal-loading__balance-top']}>
                    <Skeleton borderRadius={0} height={24} isLoading={true} width={'50%'} />
                    <Skeleton borderRadius={0} height={44} isLoading={true} width={'50%'} />
                </div>
                <div className={styles['withdrawal-loading__balance-bottom']}>
                    <Skeleton borderRadius={0} height={48} isLoading={true} width={'100%'} />
                    <Skeleton borderRadius={4} height={19} isLoading={true} width={'50%'} />
                </div>
            </div>

            <div className={styles['withdrawal-loading-bottom']}>
                <div className={styles['withdrawal-loading-bottom__chips']}>
                    <Skeleton borderRadius={100} height={32} isLoading={true} width={'13.61%'} />
                    <div className={styles['withdrawal-loading-bottom__chips--items']}>
                        <Skeleton
                            borderRadius={100}
                            count={3}
                            direction='row'
                            gap={8}
                            height={32}
                            isLoading={true}
                            width={'100%'}
                        />
                    </div>
                </div>
                <div className={styles['withdrawal-loading-bottom-lenta']}>
                    {Array.from({ length: 8 }).map((_, index) => (
                        <div
                            // eslint-disable-next-line @eslint-react/no-array-index-key
                            key={index}
                            className={styles['withdrawal-loading-bottom-lenta__item']}
                        >
                            <Skeleton borderRadius={3} height={24} isLoading={true} width={'26%'} />
                            <Skeleton
                                borderRadius={3}
                                height={24}
                                isLoading={true}
                                width={'100%'}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
